import TableCellNombre from '../../Components/Includes/Table/TableCellNombre'

export const nombre = {
  id: "number",
  sort: true,
  padding: true,
  label: "Nombre",
  component: TableCellNombre
}
